import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPitchInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.5,
			cy: 11,
			r: 10,
			fill: "#131924",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.5,
			cy: 6,
			r: 1.5,
			fill: "#ffffff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 10C12 9.17157 11.3284 8.5 10.5 8.5C9.67157 8.5 9 9.17157 9 10V16C9 16.8284 9.67157 17.5 10.5 17.5C11.3284 17.5 12 16.8284 12 16V10Z",
			fill: "#ffffff"
		})
	]
});
export default SvgPitchInfo;
